export default __webpack_public_path__ + "static/media/yummy-menu-mobile.0f2336bb.jpg";